import { serializeError } from 'serialize-error'

const logger = (
	message: string,
	error: Error,
	extraInfo: { [key: string]: number | string }
): void => {
	if (typeof window !== 'undefined' && window.newrelic) {
		const serializedError = serializeError(error)
		window.newrelic.noticeError(message, {
			errorName: serializedError.name || 'n/a',
			errorMessage: serializedError.message || 'n/a',
			errorStack: serializedError.stack || 'n/a',
			...extraInfo,
		})
	}
}

export default logger
